import { render, staticRenderFns } from "./HistoryHot.vue?vue&type=template&id=10704e8f&scoped=true&"
import script from "./HistoryHot.vue?vue&type=script&lang=js&"
export * from "./HistoryHot.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHot.vue?vue&type=style&index=0&id=10704e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10704e8f",
  null
  
)

export default component.exports